module.exports = __webpack_public_path__ + "img/banner-sm3.82b827f4.jpg";